import { get, del } from '../utils/request';
import { OperationLog, PaginatedResponse } from '../types';

// 获取操作日志列表
export async function getLogList(params?: any): Promise<PaginatedResponse<OperationLog>> {
  return get<PaginatedResponse<OperationLog>>('/admin/logs', params);
}

// 获取操作类型列表
export async function getOperationTypes(): Promise<string[]> {
  return get<string[]>('/admin/logs/operation-types');
}

// 清空操作日志
export async function clearLogs(): Promise<{ deletedCount: number }> {
  return del<{ deletedCount: number }>('/admin/logs');
}
